import React from 'react';
import './ConfirmationModal.css';

const ConfirmationModal = ({
    open,
    title,
    message,
    icon,
    type = 'info',
    actionLabel = 'Aceptar',
    onClose,
    onAction,
    showAction = true,
}) => {
    if (!open) return null;

    return (
        <div className="confirmation-modal-backdrop" role="dialog" aria-modal="true">
            <div className={`confirmation-modal confirmation-modal-${type}`}>
                {icon && <div className="confirmation-modal-icon">{icon}</div>}
                
                <h2 className="confirmation-modal-title">{title}</h2>
                
                {message && (
                    <p className="confirmation-modal-message">{message}</p>
                )}

                <div className="confirmation-modal-actions">
                    {showAction && (
                        <button
                            type="button"
                            className={`confirmation-modal-btn confirmation-modal-btn-${type}`}
                            onClick={() => {
                                if (onAction) onAction();
                                onClose();
                            }}
                        >
                            {actionLabel}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
